var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHappy1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM8.03477 14.68C8.75785 16.2129 10.2698 17.25 12.0001 17.25C13.7304 17.25 15.2423 16.2129 15.9654 14.68C16.1421 14.3054 16.5891 14.145 16.9637 14.3217C17.3383 14.4984 17.4988 14.9453 17.3221 15.32C16.3695 17.3394 14.3523 18.75 12.0001 18.75C9.64784 18.75 7.6307 17.3394 6.67812 15.32C6.50141 14.9453 6.66185 14.4984 7.03648 14.3217C7.4111 14.145 7.85805 14.3054 8.03477 14.68ZM16 9.5C16 10.3284 15.5523 11 15 11C14.4477 11 14 10.3284 14 9.5C14 8.67157 14.4477 8 15 8C15.5523 8 16 8.67157 16 9.5ZM9 11C8.44771 11 8 10.3284 8 9.5C8 8.67157 8.44771 8 9 8C9.55228 8 10 8.67157 10 9.5C10 10.3284 9.55228 11 9 11Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappy1);
export default __webpack_public_path__ + "static/media/happy-1.fa8f9346cd997e48ab2f6c288a888ad8.svg";
export { ForwardRef as ReactComponent };